const remoteConfigLifecyclePlugin = ({ remoteConfig, port }) => {
    remoteConfig.on('sync', ({ current }) => port.emit('remoteConfig', current));
    const onLoad = () => {
        remoteConfig.sync();
    };
    const onStart = () => {
        remoteConfig.load();
    };
    const onStop = () => {
        remoteConfig.stop();
    };
    const onUnlock = () => {
        remoteConfig.sync();
    };
    return { onLoad, onUnlock, onStart, onStop };
};
const remoteConfigPlugin = {
    id: 'remoteConfigPlugin',
    type: 'plugin',
    factory: remoteConfigLifecyclePlugin,
    dependencies: ['remoteConfig', 'port'],
    public: true,
};
export default remoteConfigPlugin;
